module.exports = __webpack_public_path__ + "img/nutrition-less-sugar.fe0f69f.svg";